import { render, staticRenderFns } from "./selfOrder.vue?vue&type=template&id=5618d974&scoped=true&"
import script from "./selfOrder.vue?vue&type=script&lang=js&"
export * from "./selfOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618d974",
  null
  
)

export default component.exports